// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__12U_l","header":"ReportDetails_header__qPuO2","title":"ReportDetails_title__3ijbC","left":"ReportDetails_left__3yaKP"};